import { useState, useEffect } from 'react';
import { fetchAuthSession, signOut } from '../../../utils/authSession';

export const useAdminAuth = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  
  useEffect(() => {
    const checkSession = async () => {
      setIsLoading(true);
      try {
        const session = await fetchAuthSession();
        const accessToken = session.tokens?.accessToken;
        const groups = accessToken?.payload?.["cognito:groups"] || [];
        const convaiadmin_accessToken = sessionStorage.getItem("accessToken");

        if (
          groups.includes("ConvAI_Admin") &&
          convaiadmin_accessToken === accessToken.toString()
        ) {
          setIsAuthenticated(true);
        } else {
          sessionStorage.removeItem("accessToken");
          await signOut();
          setIsAuthenticated(false);
        }
      } catch (err) {
        setIsAuthenticated(false);
      } finally {
        setIsLoading(false);
      }
    };
    checkSession();
  }, []);

  return { isLoading, isAuthenticated };
};